(function () {
  var productId = window.productId || null;
  if (!productId) return;

  var storageKey = "salesCount_" + productId;
  var salesCount = localStorage.getItem(storageKey);

  if (!salesCount) {
    salesCount = Math.floor(Math.random() * (150 - 99 + 1)) + 99;
    localStorage.setItem(storageKey, salesCount);
  }

  window._salesCount = salesCount;

  // Update the text only if it's still set to 0 or empty
  function tryInjectSalesCount() {
    var el = document.getElementById("ccpsalescount");
    if (el && (el.textContent === "0" || el.textContent.trim() === "")) {
      el.textContent = salesCount;
    } else if (!el) {
      setTimeout(tryInjectSalesCount, 50);
    }
  }

  tryInjectSalesCount();
})();
